import DeliveryMethodsPage from './DeliveryMethodsPage'

export default DeliveryMethodsPage
